module.exports = __webpack_public_path__ + "static/media/purewatt-gb-2.684d50c5.jpg";